const notificationsTutorial = {
  module: 'notifications',
  moduleName: 'Notifications',
  steps: [
    { target: '.nc-item', position: 'top', title: 'Notifications', description: 'System alerts, device events, and security notifications in one feed.' },
    { target: '.nc-sev-badge', position: 'bottom', title: 'Severity', description: 'Alerts are color-coded by severity for quick triage.' },
    { target: '.nc-checkbox', position: 'bottom', title: 'Bulk Actions', description: 'Select multiple notifications to acknowledge or dismiss at once.' },
  ],
};
export default notificationsTutorial;
